import { makeAuthRequest } from '../makeApiRequest'
import configServer from '../../configs/service'
import sanitizeUrl from "../../helpers/sanitizeUrl"
import qs from 'qs'

const isLocalhost = () => `${window.location.href}`.match(/localhost/)
const apiRequest = makeAuthRequest(true)
const prefix = process.env.REACT_APP_API || 'api/order'
const baseURL = configServer.url
const factoryURL = configServer.factory_url

export const createBatchByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/create-batch-by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const listLevels = () => {
    return apiRequest({
        url: `${prefix}/batches/levels`,
        method: 'GET',
    })
}

export const listPartner = (query) => {
    const vQuery = (query && query.includes('hidden=')) ? query : query + '&hidden=false'
    return apiRequest({
        url: `${prefix}/partners?${vQuery}`,
        method: 'GET',
    })
}

export const listErrorConfirmed = (query) => {
    return apiRequest({
        url: `${prefix}/batches/list-error-confirmed?${query}`,
        method: 'GET',
    })
}

export const listSku = () => {
    return apiRequest({
        url: `${prefix}/sku`,
        method: 'GET',
    })
}

export const listUserCut = () => {
    return apiRequest({
        url: `${prefix}/batches/laser/users`,
        method: 'GET',
    })
}

export const informationBatches = (batchId) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}`,
        method: 'GET',
    })
}

export const listItemBatches = (batchId, query) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/items?${query}`,
        method: 'GET',
    })
}

export const isAllowedRecycle = (batchId) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/is-allowed-recycle`,
        method: 'POST',
    })
}

export const recycleBatch = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/recycle-batch/${batchId}`,
        method: 'POST',
        data: payload,
    })
}

export const recycleBatchV2 = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/v2/batches/${batchId}/recycle`,
        method: 'POST',
        data: payload,
    })
}

export const recycleBatchDetails = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/v2/batches/${batchId}/recycle-with-details`,
        method: 'POST',
        data: payload,
    })
}

export const listBatchesV4 = (payload) => {
    // return apiRequest({
    //     url: `http://localhost:3721/v4/batches/search`,
    //     method: 'POST',
    //     data: payload,
    // })

    return apiRequest({
        url: `${prefix}/v4/batches/search`,
        method: 'POST',
        data: payload,
    })
}

export const exportItemJson = (batchId, query) => {
    return sanitizeUrl(`${baseURL}/${prefix}/batch/${batchId}/export-items-json?${query}`)
}

export const ExportErrorDetail = (batchId) => {
    return sanitizeUrl(`${baseURL}/${prefix}/batch/${batchId}/export-error-pieces-json`)
}

export const exportItemCsv = (batchId, data) => {
    // return sanitizeUrl(`${baseURL}/${prefix}/batch/${batchId}/export-items-csv?${query}`)
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batch/${batchId}/export-items-csv`,
        method: 'POST',
        data,
    })
}

export const toggleOnHold = (orderId, slug) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/${slug}`,
        method: 'POST',
    })
}

export const markDone = (orderId) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/mark-done`,
        method: 'POST',
    })
}

export const listHistory = (batchId) => {
    return apiRequest({
        url: `${prefix}/batch/${batchId}/histories`,
        method: 'GET',
    })
}

export const updateNewPartnerV2 = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/v2/batches/${batchId}/partner`,
        method: 'POST',
        data: payload,
    })
}

export const updatePartnerSewing = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/partner-sewing`,
        method: 'POST',
        data: payload,
    })
}

export const markPrinted = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/mark-printed`,
        method: 'POST',
        data: payload,
    })
}

export const getMarkInformationV2 = (barcode) => {
    return apiRequest({
        url: `${prefix}/v2/orders/qr/${barcode}/items`,
        method: 'GET',
    })
}

export const markCompletedByOrderIdV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/batches/mark-completed-by-order-ids`,
        method: 'POST',
        data: payload,
    })
}

export const markCompleted1STByOrderId = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/mark-completed-1st-by-order-ids`,
        method: 'POST',
        data: payload,
    })
}

export const getMarkInformationV3 = (barcode) => {
    return apiRequest({
        url: `${prefix}/v3/orders/qr/${barcode}/items`,
        method: 'GET',
    })
}

export const markError = (barcode, payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/${barcode}/mark-error`,
        method: 'PUT',
        data: payload,
    })
}

export const getMarkInformation = (barcode) => {
    return apiRequest({
        url: `${prefix}/orders/qr/${barcode}/items`,
        method: 'GET',
    })
}

export const markCompletedByOrderId = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/mark-completed-by-order-ids`,
        method: 'POST',
        data: payload,
    })
}

export const markItemTransferred = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/mark-item-transferred`,
        method: 'POST',
        data: payload,
    })
}

export const listBatchesV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/batches/search`,
        method: 'POST',
        data: payload,
    })
}

export const updateNoteBatch = (orderId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${orderId}/note`,
        method: 'POST',
        data: payload,
    })
}

export const exportBatchItems = (query) => {
    return apiRequest({
        url: sanitizeUrl(`${baseURL}/${prefix}/batches/exports-items`),
        method: 'POST',
        data: query,
    })
}

export const exportBatchs = (query) => {
    return apiRequest({
        url: sanitizeUrl(`${baseURL}/${prefix}/batches/exports-batches?${query}`),
        method: 'GET',
    })
}

export const exportBatchItemsOverTime = (query) => {
    return sanitizeUrl(`${baseURL}/${prefix}/batches/export-items-overtime?${query}`)
}

export const batchesStatistics = () => {
    return apiRequest({
        url: `${prefix}/batches/statistic`,
        method: 'GET',
    })
}

export const batchesNotPushStatics = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/not-pushed/statistic`,
        method: 'GET',
        params: payload,
    })
}

// Mặc định gọi API dashboard thêu bản v2 (aggregate); thêm ?version=v1 trên thanh địa chỉ để quay về bản cũ
// Trả URL đầy đủ: prefix lấy từ biến global `prefix` của file
const getEmbroideryDashboardPath = (path) => {
    let version = ''
    try {
        version = new URLSearchParams(window.location.search).get('version')
    } catch (e) {
        version = ''
    }
    return version === 'v1' ? `${prefix}/dashboard/embroidery/${path}` : `${prefix}/v2/dashboard/embroidery/${path}`
}

export const embroideryDashboardOverview = (params) => {
    return apiRequest({
        url: getEmbroideryDashboardPath('overview'),
        method: 'GET',
        params,
    })
}

export const embroideryDashboardFilterOptions = () => {
    return apiRequest({
        url: getEmbroideryDashboardPath('filter-options'),
        method: 'GET',
    })
}

export const embroideryDashboardItems = (params) => {
    return apiRequest({
        url: getEmbroideryDashboardPath('items'),
        method: 'GET',
        params,
    })
}

// Xuất CSV toàn bộ item khớp bộ lọc (FR-007): thành công trả chuỗi CSV, lỗi (vd tập rỗng) trả JSON {success:false, error}
export const embroideryDashboardItemsExportCsv = (params) => {
    return apiRequest({
        url: getEmbroideryDashboardPath('items/export-csv'),
        method: 'GET',
        params,
        responseType: 'text',
    })
}

export const uploadOrderCsv = () => {
    return sanitizeUrl(`${baseURL}/${prefix}/bulk/orders/csv`)
}

export const listOrderV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/orders/search`,
        method: 'POST',
        data: payload,
    })
}

export const updateNoteOrder = (orderId, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/note`,
        method: 'POST',
        data: payload,
    })
}

export const deleteNoteOrder = (orderId) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/note`,
        method: 'DELETE',
    })
}

export const listSizeBySku = (skuId) => {
    return apiRequest({
        url: `${prefix}/sku/${skuId}/sizes`,
        method: 'GET',
    })
}

export const brandingInfo = (payload) => {
    return apiRequest({
        url: `${prefix}/branding/info`,
        method: 'POST',
        data: payload,
    })
}

export const createBatchThankCard = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/thank-card-orders/create-batch`,
        method: 'POST',
        data: payload,
    })
}

export const listBatchItemError = (query) => {
    //let prefix = 'http://localhost:3721'
    return apiRequest({
        url: `${prefix}/batch-items/errors?${query}`,
        method: 'GET',
    })
}

export const exportBatchItemError = (data) => {
    //let prefix = 'http://localhost:3721'
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batch-items/errors/export-csv`,
        method: 'POST',
        data
    })
}

export const printedFileSession = (payload) => {
    return apiRequest({
        url: `${prefix}/printed-file/session`,
        method: 'POST',
        data: payload,
    })
}

export const printedFileSessionJobs = (query) => {
    return apiRequest({
        url: `${prefix}/printed-file/session/jobs?${query}`,
        method: 'GET',
    })
}

export const printedFileRetry = (payload) => {
    return apiRequest({
        url: `${prefix}/printed-file/session/retry`,
        method: 'POST',
        data: payload,
    })
}

export const getInformationConfirmed = (query) => {
    return apiRequest({
        url: `${prefix}/batches/item/mark-confirmed?${query}`,
        method: 'GET',
    })
}

export const updateInformationConfirmed = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/mark-confirmed`,
        method: 'POST',
        data: payload,
    })
}

export const updateMarkError = (barcode, payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/${barcode}/mark-error`,
        method: 'PUT',
        data: payload,
    })
}

export const markAutoWaitToSew = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/auto-wait-to-sew`,
        method: 'POST',
        data: payload,
    })
}

export const unmarkPrinted = (barcode) => {
    return apiRequest({
        url: `${prefix}/orders/qr/${barcode}/unmark-printed`,
        method: 'GET',
    })
}

export const saveHistory = (barcode) => {
    return apiRequest({
        url: `${prefix}/prints/${barcode}/save-history`,
        method: 'POST',
    })
}

export const getDetailBarcode = (barcode, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${barcode}/details`,
        method: 'GET',
        params: payload
    })
}

export const getEmbroideryInfo = (barcode, payload) => {
    return apiRequest({
        url: `${prefix}/order/${barcode}/embroidery_info`,
        method: 'GET',
        params: payload
    })
}

export const getHistoryOrder = (orderId) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/histories`,
        method: 'GET',
    })
}

export const deleteBasket = (orderId) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/basket-number`,
        method: 'DELETE',
    })
}

export const unMarkPrintedOrder = (orderId) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/unmark-printed`,
        method: 'POST',
    })
}

export const printQrOrder = (barcode) => {
    return sanitizeUrl(`${baseURL}/${prefix}/prints/${barcode}/qr.jpg`)
}

export const updateFailedPartials = (orderId, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/failed-partials`,
        method: 'POST',
        data: payload,
    })
}

export const updateBasketNumber = (orderId, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/basket-number`,
        method: 'POST',
        data: payload,
    })
}

export const getDetailPartner = (partnerId) => {
    return apiRequest({
        url: `${prefix}/partners/${partnerId}`,
        method: 'GET',
    })
}

export const getListItemPartner = (partnerId, payload) => {
    return apiRequest({
        url: `${prefix}/partners/${partnerId}/batches`,
        method: 'POST',
        data: payload,
    })
}

export const updatePartner = (partnerId, payload) => {
    return apiRequest({
        url: `${prefix}/partners/${partnerId}`,
        method: 'POST',
        data: payload,
    })
}

export const deletePartner = (partnerId) => {
    return apiRequest({
        url: `${prefix}/partners/${partnerId}`,
        method: 'DELETE',
    })
}

export const createPartnerV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/partners`,
        method: 'POST',
        data: payload,
    })
}

export const markPrintedOrder = (barcode) => {
    return apiRequest({
        url: `${prefix}/orders/qr/${barcode}/mark-printed`,
        method: 'POST',
    })
}

export const retryBatchPrintedFile = (payload) => {
    return apiRequest({
        url: `${prefix}/printed-file/retry-by-batch-name`,
        method: 'POST',
        data: payload,
    })
}

export const retryOrderPrintedFile = (payload) => {
    return apiRequest({
        url: `${prefix}/printed-file/retry-by-order-number`,
        method: 'POST',
        data: payload,
    })
}

export const getInformationBatchBySku = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/details-by-sku`,
        method: 'POST',
        data: payload,
    })
}

export const exportBatchDetailBySku = (data) => {
    // return sanitizeUrl(`${baseURL}/${prefix}/batches/details-by-sku/export-csv?${query}`)
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batches/details-by-sku/export-csv`,
        method: 'POST',
        data,
    })
}

export const getInformationBatchByName = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/details-by-name`,
        method: 'POST',
        data: payload,
    })
}

export const getInformationBatchByNameV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/batches/details-by-name`,
        method: 'POST',
        data: payload,
    })
}

export const getSewingThreadWarning = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/sewing-thread-warning`,
        method: 'POST',
        data: payload,
    })
}

export const updateStatusBatch = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/status`,
        method: 'POST',
        data: payload,
    })
}

export const updateStatusBatchV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/status`,
        method: 'POST',
        data: payload,
    })
}

// Giao may bằng ảnh lệnh may: kiểm tra danh sách lô có giao may được không
export const validateSewingHandover = (batchNames) => {
    return apiRequest({
        url: `${prefix}/sewing-handovers/validate`,
        method: 'POST',
        data: {batchNames},
    })
}

// Giao may: multipart gồm partner, batches (JSON) và ảnh image_0..image_n
export const createSewingHandover = (formData, onUploadProgress) => {
    return apiRequest({
        url: `${prefix}/sewing-handovers`,
        method: 'POST',
        data: formData,
        timeout: 0,
        onUploadProgress,
    })
}

export const updateCreatorName = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/update-creator-name`,
        method: 'PUT',
        data: payload,
    })
}

export const updateBatchReceiveSewName = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/update-receive-sew-name`,
        method: 'POST',
        data: payload,
    })
}

export const bulkCancelOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/cancel/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkExportLinksOrder = (query) => {
    return sanitizeUrl(`${baseURL}/${prefix}/bulk/orders/export-links?${query}`)
}

export const bulkExportLinksOrderPosterCanvas = (query) => {
    return sanitizeUrl(`${baseURL}/${prefix}/bulk/orders/export-links-poster-canvas?${query}`)
}

export const bulkExportLinksOrderRepaired = () => {
    return sanitizeUrl(`${baseURL}/${prefix}/bulk/orders/export-repaired-links`)
}

export const bulkGenerateOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/generate/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkMarkArchivedOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/mark-archived/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkMarkDoneOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/mark-done/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkMarkPrintedOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/mark-printed`,
        method: 'POST',
        data: payload,
    })
}

export const bulkMarkUnprintedOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/mark-unprinted/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkOnHoldOrderByIdsV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/v2/on-hold/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkSyncFulfillmentOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/sync-fulfill-design-and-retry/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const bulkUndoOnHoldOrderByIds = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/undo-on-hold/by-ids`,
        method: 'POST',
        data: payload,
    })
}

export const singleCancelOrder = (orderId, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/cancel`,
        method: 'POST',
        data: payload,
    })
}

export const createBatchV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/v2/create-batch`,
        method: 'POST',
        data: payload,
    })
}

export const createBatchByNumberV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/v2/create-batch-by-numbers`,
        method: 'POST',
        data: payload,
    })
}

export const listNumberOrderByBatches = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/list-number-by-batches`,
        method: 'POST',
        data: payload,
    })
}

export const createBatchByNumberV3 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/v3/create-batch-by-numbers`,
        method: 'POST',
        data: payload,
    })
}

export const createBatchSewingRepair = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/sewing-repair/create-batch`,
        method: 'POST',
        data: payload,
    })
}

// @FAC-25966: xem trước kết quả tái tạo lô sửa may (chỉ đọc) — cùng logic chia lô với createBatchSewingRepairV2
export const previewBatchSewingRepairV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/sewing-repair/v2/preview`,
        method: 'POST',
        data: payload,
    })
}

// @FAC-25966: payload { order_ids } — BE tự chia lô theo đối tác may gốc
export const createBatchSewingRepairV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/sewing-repair/v2/create-batch`,
        method: 'POST',
        data: payload,
    })
}

export const createBatchV3 = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/orders/v3/create-batch`,
        method: 'POST',
        data: payload,
    })
}

export const createOrder = (payload) => {
    return apiRequest({
        url: `${prefix}/orders`,
        method: 'POST',
        data: payload,
    })
}

export const exportLinkByNumber = (payload) => {
    return apiRequest({
        url: `${prefix}/exports/by-numbers`,
        method: 'POST',
        data: payload,
    })
}

export const bulkExportByFieldId = (fieldId) => {
    return sanitizeUrl(`${baseURL}/${prefix}/exports/${fieldId}`)
}

export const exportOrderByQueryV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/exports/orders/sheet-by-query`,
        method: 'POST',
        data: payload,
    })
}

export const exportCsvOrderByQuery = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/v2/exports/orders/csv-by-query`,
        method: 'POST',
        data,
    })
}

export const exportCsvWarningOrderByQuery = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/exports/alert-item/csv-by-query`,
        method: 'POST',
        data,
    })
}

export const generatePrintOrder = (orderId) => {
    return apiRequest({
        url: `${prefix}/generate/${orderId}`,
        method: 'POST',
    })
}

export const generatePrintOrderByQuery = (payload) => {
    return apiRequest({
        url: `${prefix}/generate/by-query`,
        method: 'POST',
        data: payload,
    })
}

export const syncFulfillmentDesign = (orderId) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/sync-fulfill-design`,
        method: 'POST',
    })
}

export const updateDesignOrder = (orderId, type, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${orderId}/${type}`,
        method: 'POST',
        data: payload,
    })
}

export const requestUpdateDesign = (barcodeNumber, data) => {
    return apiRequest({
        url: `${prefix}/request-update/${barcodeNumber}/design`,
        method: 'POST',
        data: data,
    })
}

export const bulkMergeBatches = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/batches/merge`,
        method: 'POST',
        data: payload,
    })
}

export const getItemsQCCompleteFailed = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/items-qc-complete-failed`,
        method: 'POST',
        data: payload,
    })
}

export const getListBatchesCutting = (payload) => {
    const { limit, page } = Object.assign({}, payload)
    return apiRequest({
        url: `${prefix}/batches/laser?page=${page}&limit=${limit}`,
        method: 'POST',
        data: payload,
    })
}

export const exportBatchesCutting = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batches/laser/export-csv`,
        method: "POST",
        data: payload,
    })
}

export const startCutLaze = (id, data) => {
    return apiRequest({
        url: `${prefix}/batches/laser/${id}`,
        method: 'POST',
        data
    })
}

export const receiveLazeCut = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/laser/receive`,
        method: 'POST',
        data: payload,
    })
}

export const finishCutLaze = (id) => {
    return apiRequest({
        url: `${prefix}/batches/laser/${id}`,
        method: 'PUT',
    })
}

export const repairWrongPendingBatches = (payload) => {
    return apiRequest({
        url: `${prefix}/repair-wrong-pending-batches`,
        method: 'POST',
        data: payload,
    })
}

export const getListFailePieces = (payload) => {
    const { limit, page, ...data } = Object.assign({}, payload)
    return apiRequest({
        url: `${prefix}/batches/list-failed-pieces?page=${page}&limit=${limit}`,
        method: 'POST',
        data: data
    })
}

export const createBatchByIdsPiecesError = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/create-batch-error-details`,
        method: 'POST',
        data: payload
    })
}

export const markBatchPackaged = async (batchId) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/mark-packaged`,
        method: 'POST',
    }).then(res => res.data)
}

export const getBatchesPackaged = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/packing/get-packaged`,
        method: 'POST',
        data: payload,
    }).then(res => res.data)
}

export const exportBatchesPackaged = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/packing/export-csv`,
        data: payload,
        method: 'POST',
    })
}

export const getListBrand = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/order/get-list-brand`,
        method: 'POST',
        data: payload,
    })
}

export const getListSku = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/order/sku/search`,
        method: 'POST',
        data: payload,
    })
}

export const markSewingRepair = (id, payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/${id}/mark-sewing-repair`,
        method: 'PUT',
        data: payload,
    })
}

export const markSewingThreadColor = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/sewing-thread-qc`,
        method: 'POST',
        data: payload,
    })
}

export const getListPackingItem = (payload) => {
    return apiRequest({
        url: `${prefix}/orders/items`,
        method: 'GET',
        params: payload,
    })
}
export const getListPackingItemUsers = (payload) => {
    return apiRequest({
        url: `${prefix}/orders/items/users`,
        method: 'GET',
        params: payload,
    })
}
export const exportListPackingItem = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/orders/packing/export-csv`,
        method: 'POST',
        data: payload,
    })
}

export const getListAttachTagItem = (payload) => {
    return apiRequest({
        url: `${prefix}/orders/items/tagged`,
        method: 'GET',
        params: payload,
    })
}

export const exportListAttachTagItem = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/orders/tagging/export-csv`,
        method: 'POST',
        data: payload,
    })
}

export const markOrderPackaged = async (orderId, ip) => {
    //let prefix = 'http://localhost:3721'
    return apiRequest({
        url: `${prefix}/orders/${orderId}/mark-packaged`,
        method: 'PUT',
        data: ip
    }).then(res => res.data)
}

export const getOrderForPackaging = ({ barcodeStr, get_basket = false }) => {
    //let prefix = 'http://localhost:3721'
    return apiRequest({
        url: `${prefix}/orders/${barcodeStr}/mark-packaged?get_basket=${get_basket}`,
        method: 'GET',
    }).then(res => res.data)
}

export const getOrderForAttachTag = ({ barcodeStr }) => {
    return apiRequest({
        url: `${prefix}/orders/${barcodeStr}/mark-tagged`,
        method: 'GET',
    }).then(res => res.data)
}

export const markOrderAttachTag = ({ barcodeStr }) => {
    return apiRequest({
        url: `${prefix}/orders/${barcodeStr}/mark-tagged`,
        method: 'PUT',
    }).then(res => res.data)
}

export const getListSewingRepair = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/sewing-repair`,
        method: 'GET',
        params: payload,
    })
}

export const getListSewingRepairInBatch = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/sewing-repair-in-batch`,
        method: 'GET',
        params: payload,
    })
}

export const exportListSewingRepairInBatch = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batches/item/sewing-repair-in-batch/export-csv`,
        method: 'POST',
        data: payload,
    })
}

export const markMex = (id) => {
    return apiRequest({
        url: `${prefix}/batches/mex/${id}`,
        method: 'POST',
    })
}

export const getListMex = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/mex`,
        method: 'POST',
        data: payload,
    })
}

export const exportListMex = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batches/mex/export-csv`,
        method: 'POST',
        data: payload,
    })
}

export const getListPartnerWithSku = () => {
    return apiRequest({
        url: `${prefix}/batches/list-partner-with-sku`,
        method: 'GET',
    })
}

export const getListBatchRule = (data) => {
    //let prefix  ='http://localhost:3721'
    return apiRequest({
        url: `${prefix}/v2/batch-rule/search`,
        method: 'POST',
        data
    })
}
export const updateRule = (id, payload) => {
    //let prefix  ='http://localhost:3721'

    return apiRequest({
        url: `${prefix}/v2/batch-rule/${id}`,
        method: 'PUT',
        data: payload,
    })
}

export const getRuleDetails = (id) => {
    //let prefix  ='http://localhost:3721'

    return apiRequest({
        url: `${prefix}/v2/batch-rule/${id}`,
        method: 'GET',
    })
}

export const createRule = (payload) => {
    //let prefix  ='http://localhost:3721'
    return apiRequest({
        url: `${prefix}/v2/batch-rule`,
        method: 'POST',
        data: payload
    })
}

export const getListLazeError = (payload) => {
    return apiRequest({
        url: `${prefix}/laser/items-mark-error/search`,
        method: 'POST',
        data: payload,
    })
}

export const exportListLazeError = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/laser/items-mark-error/export-csv`,
        method: 'POST',
        data: payload,
    })
}

export const cuttingLazeError = (payload) => {
    return apiRequest({
        url: `${prefix}/laser/mark-error`,
        method: 'POST',
        data: payload,
    })
}

export const markBatchSewed = (id) => {
    return apiRequest({
        url: `${prefix}/batches/${id}/mark-sewed`,
        method: 'POST',
    })
}

export const getListItemsAddToBasket = async (payload, cancelToken) => {
    return apiRequest({
        url: `${prefix}/baskets/items-added-to-basket`,
        method: 'GET',
        params: payload,
        cancelToken
    })
}

export const exportListItemsAddToBasket = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/baskets/items-added-to-basket/csv`,
        method: 'POST',
        data: payload,
    })
}

export const getListItemsRemoveFromBasket = (payload, cancelToken) => {
    return apiRequest({
        url: `${prefix}/baskets/items-removed-from-basket`,
        method: 'GET',
        params: payload,
        cancelToken
    })
}

export const exportListItemsRemoveFromBasket = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/baskets/items-removed-from-basket/csv`,
        method: 'POST',
        data: payload,
    })
}

export const statisticSewed = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/statistic-sewed`,
        method: 'GET',
        params: payload,
    })
}

export const exportStatisticSewed = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/statistic-sewed/export`,
        method: 'GET',
        params: payload,
    })
}

export const statisticQCHT = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/statistic-QCHT`,
        method: 'GET',
        params: payload,
    })
}

export const exportStatisticQCHT = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/statistic-QCHT/export`,
        method: 'GET',
        params: payload,
    })
}

export const statisticPackaged = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/statistic-packaged`,
        method: 'GET',
        params: payload,
    })
}

export const exportBatchItemQuantity = (query) => {
    return apiRequest({
        url: sanitizeUrl(`${baseURL}/${prefix}/batches/exports-batch-quantity?${query}`),
        method: 'GET',
    })
}

export const exportSewingGroups = (query) => {
    return apiRequest({
        url: sanitizeUrl(`${baseURL}/${prefix}/batches/exports-sewing-groups?${query}`),
        method: 'GET',
    })
}

export const markFinishPeriods = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/mark-finish-periods`,
        method: 'POST',
        data: payload,
    })
}

export const getListFinishPeriods = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/finish-periods/get-list`,
        method: 'GET',
        params: payload,
    })
}

export const exportListFinishPeriods = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/finish-periods/export`,
        method: 'GET',
        params: payload,
    })
}

export const getUrlUploadArtwork = (payload) => {
    return apiRequest({
        url: `${prefix}/artworks/signed-url`,
        method: 'POST',
        data: payload,
    })
}

export const saveEmbroideryInfo = (batchItemId, payload) => {
    return apiRequest({
        url: `${prefix}/v2/batch-items/${batchItemId}/embroidery_info`,
        method: 'POST',
        data: payload,
    })
}

export const suggestOrdersSameEmbroideryInfo = (id, payload) => {
    return apiRequest({
        url: `${prefix}/orders/${id}/suggest-orders-same-embroidery-info`,
        method: 'POST',
        data: payload,
    })
}

export const reuseEmbroideryInfo = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/items/reuse-embroidery-info`,
        method: 'POST',
        data: payload
    })
}

export const uploadEmbroideryFile = (batchItemId, payload) => {
    return apiRequest({
        url: `${prefix}/batch-items/${batchItemId}/embroidery_upload`,
        method: 'POST',
        data: payload,
    })
}

export const deleteEmbroideryFile = (batchItemId, payload) => {
    return apiRequest({
        url: `${prefix}/batch-items/${batchItemId}/embroidery_upload`,
        method: 'DELETE',
        data: payload,
    })
}

export const getListMaterial = (params) => {
    return apiRequest({
        url: `${factoryURL}/api/order/materials`,
        method: 'GET',
        params,
    })
}

export const retryPrintedFileSession = (data) => {
    return apiRequest({
        url: `${prefix}/printed-file/session/retry`,
        method: 'POST',
        data,
    })
}

export const getItemsColorSystemError = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/color-mode-error-items`,
        method: 'POST',
        data: payload,
    })
}

export const getItemsUnpushKitCard = (payload) => {
    return apiRequest({
        url: `${prefix}/orders/aggregate-unprinted-same-design`,
        method: 'POST',
        data: payload,
    })
}

export const saveDelivery = (id, data) => {
    return apiRequest({
        url: `${prefix}/batches/${id}/assign-sewing-group`,
        method: 'POST',
        data,
    })
}

export const getListCategory = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/order/sku-catalog/getList`,
        method: 'POST',
        data,
    })
}

export const callAdditionalApi = (api) => {
    const { meta, url } = { ...api }
    const { method, query } = { ...meta }
    const request = {
        url: url,
        method: method,
    }

    if (query) {
        if (method === 'GET') {
            request.params = query
        }

        if (method === 'POST' || method === 'PUT') {
            request.data = query
        }
    }

    return apiRequest(request)
}

export const callActionApi = (api) => {
    const { meta, url } = { ...api }
    const { method, query } = { ...meta }
    const request = {
        url: url,
        method: method,
    }
    if (query) {
        if (method === 'GET') {
            request.params = query
        }

        if (method === 'POST' || method === 'PUT') {
            request.data = query
        }
    }

    return apiRequest(request)
}

export const exportBatchsEmbroidery = (query) => {
    return apiRequest({
        url: sanitizeUrl(`${baseURL}/${prefix}/batches/exports-items-embroider?${query}`),
        method: 'GET',
    })
}

export const exportBatchsEmbroideryDetails = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batches/embroidery-details/export-csv`,
        method: 'POST',
        data,
    })
}

export const downloadFile = (id, data) => {
    return apiRequest({
        url: `${prefix}/batches/merge/${id}`,
        method: 'POST',
        data,
    })
}

export const updateStatusRule = (id) => {
    return apiRequest({
        url: `${prefix}/v2/batch-rule/${id}/toggle`,
        method: 'PUT',
    })
}

export const getJobDetail = async (jobId) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/export-job/detail/${jobId}`,
        method: 'GET',
    })
}

export const retryJob = async (jobId) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/export-job/retry/${jobId}`,
        method: 'GET',
    })
}

export const forceRetryBatch = async (batchId) => {
    return apiRequest({
        url: `${prefix}/batches/merge-job/force-retry/${batchId}`,
        method: 'GET',
    })
}

export const markErrorEmbroidered = (id, payload) => {
    return apiRequest({
        url: `${prefix}/batches/items/${id}/mark-embroidery-error`,
        method: 'POST',
        data: payload,
    })
}

export const getListEmbroideryError = (params) => {
    return apiRequest({
        url: `${prefix}/batches/items/embroidery-errors?${params}`,
        method: 'GET',
    })
}

export const createBatchEmbroideryError = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/embroidered/create-batch`,
        method: 'POST',
        data: payload,
    })
}

export const createEmbroideryBatchesBySkus = (payload) => {
    return apiRequest({
        url: `${prefix}/bulk/embroidered/create-batches-by-skus`,
        method: 'POST',
        data: payload,
    })
}

export const exportListEmbroideryError = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/batches/items/embroidery-errors/csv?`,
        method: 'POST',
        data: payload
    })
}

export const getListProductionProcess = (payload) => {
    return apiRequest({
        url: `${factoryURL}/api/order/production/process`,
        method: 'GET',
        params: payload
    })
}

export const getItemsUnpushEmbroidery = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/not-pushed/detail`,
        method: 'GET',
        params: payload,
    })
}

export const detectDownloadFile = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/is-downloadable`,
        method: 'POST',
        data: payload
    })
}

export const forceToRGB = (batchId, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${batchId}/force-to-rgb`,
        method: 'POST',
        data: payload
    })
}

export const statisticProductionQuantityBySewingPartner = (payload) => {
    return apiRequest({
        url: `${prefix}/report/statistic-production-quantity-by-sewing-partner`,
        method: 'GET',
        params: payload
    })
}

export const getEmbroideryProductionStatistic = (payload) => {
    return apiRequest({
        url: `${prefix}/report/embroidery-production-statistic`,
        method: 'GET',
        params: payload
    })
}

export const getSewingProductivityByPartner = (payload) => {
    return apiRequest({
        url: `${prefix}/report/sewing-productivity-by-partner`,
        method: 'POST',
        data: payload
    })
}

export const pushNewItemHistory = async (barcode, event = {}) => {
    const { data } = await apiRequest({
        url: `${factoryURL}/api/order/histories/${barcode}`,
        method: 'POST',
        data: event
    })

    return data
}

export const exportBasketItemHistory = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/set-basket/set-basket-item-histories/csv`,
        method: 'POST',
        data,
    })
}

export const getReuseEmbroideryInfo = (params) => {
    return apiRequest({
        url: `${prefix}/batches/items/reuse-embroidery-info?${params}`,
        method: 'GET',
    })
}

export const deleteReuseEmbroidery = (id, data) => {
    return apiRequest({
        url: `${prefix}/batches/items/reuse-embroidery-info/${id}`,
        method: 'DELETE',
        data
    })
}

export const saveReuseEmbroideryInfo = (data, id) => {
    return apiRequest({
        url: `${prefix}/batches/items/reuse-embroidery-info/${id}`,
        method: 'PUT',
        data,
    })
}

export const unHidePartner = (partnerId) => {
    return apiRequest({
        url: `${prefix}/partners/${partnerId}/restore`,
        method: 'PUT',
    })
}

export const getReusedEmbroideryDesignOrders = (id) => {
    return apiRequest({
        url: `${prefix}/embroidery-design/${id}/get-reused-embroidery-design-orders`,
        method: 'POST',
    })
}

export const revertDesignedToPeningForItem = (batchItemId, payload) => {
    return apiRequest({
        url: `${prefix}/batch-items/${batchItemId}/change-to-pending`,
        method: 'PUT',
        data: payload,
    })
}

export const forceQCHTBatchItem = (batchItemId) => {
    return apiRequest({
        url: `${prefix}/batch-items/${batchItemId}/force-qcht`,
        method: 'POST',
    })
}

export const getSameEmbroideryDesignOrders = (data) => {
    return apiRequest({
        url: `${prefix}/orders/get-same-embroidery-design-orders`,
        method: 'POST',
        data
    })
}

export const groupBatch = (data) => {
    return apiRequest({
        url: `${prefix}/batch-groups`,
        method: 'POST',
        data
    })
}

export const getListGroupBatch = (data) => {
    return apiRequest({
        url: `${prefix}/batch-groups/search`,
        method: 'POST',
        data
    })
}

export const getListColorCheckItem = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/color-check-items`,
        method: 'POST',
        data,
    })
}

export const exportListColorCheckItem = (data) => {
    return apiRequest({
        url: `${factoryURL}/api/exporter/3d/color-check-items/csv`,
        method: 'POST',
        data,
    })
}

export const getHistoryEmbroideryDesign = (id, params) => {
    return apiRequest({
        url: `${prefix}/object-history/${id}`,
        method: 'GET',
        params
    })
}

export const removeBatchFromGroup = (id, payload) => {
    return apiRequest({
        url: `${prefix}/batches/${id}/remove-from-group`,
        method: 'DELETE',
        data: payload
    })
}

export const getFbaItemsByDesign = (payload) => {
    return apiRequest({
        url: `${prefix}/orders/fba-grouped-by-design`,
        method: 'POST',
        data: payload,
    })
}

export const getRequestPhotoByBarcode = (barcodeNumber) => {
    return apiRequest({
        url: `${prefix}/orders/${barcodeNumber}/request-photo`,
        method: 'GET',
    })
}

export const getItemSewingThreadColor = (barcode) => {
    return apiRequest({
        url: `${prefix}/batches/item/sewing-thread?barcode=${barcode}`,
        method: 'GET',
    })
}

export const updateItemSewingThreadColor = (payload) => {
    return apiRequest({
        url: `${prefix}/batches/item/sewing-thread`,
        method: 'POST',
        data: payload,
    })
}


export const getSewingHandovers = (query) => {
    return apiRequest({
        url: `${prefix}/sewing-handovers?${query}`,
        method: 'GET',
    })
}

export const getSewingHandoverHandedBy = () => {
    return apiRequest({
        url: `${prefix}/sewing-handovers/handed-by`,
        method: 'GET',
    })
}

export const getSewingHandoverDetail = (id) => {
    return apiRequest({
        url: `${prefix}/sewing-handovers/${id}`,
        method: 'GET',
    })
}

export const getSewingHandoverPrintData = (id) => {
    return apiRequest({
        url: `${prefix}/sewing-handovers/${id}/print`,
        method: 'GET',
    })
}

export const printSewingHandover = (id, payload) => {
    return apiRequest({
        url: `${prefix}/sewing-handovers/${id}/print`,
        method: 'POST',
        data: payload,
    })
}
